import { inject, Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, map, catchError, throwError } from 'rxjs';
import { ApiServiceListService } from 'src/app/_services/api/api-service-list.service';
import { PhoneNumbCheckStatus } from 'src/app/model/common.model';

@Injectable({
  providedIn: 'root'
})
export class PhoneUserValidationService {
  private toastr = inject(ToastrService);
  private apiService = inject(ApiServiceListService);


  userRoles = {
    "superadmin": ['superadmin', 'admin', 'zoneadmin'],
    "admin": ['superadmin', 'admin', 'zoneadmin'],
    "zoneadmin": ['superadmin', 'admin', 'zoneadmin'],
    "retaileradmin": ['retaileradmin', 'retailer', 'kitchenretaileradmin', 'kitchenretailer'],
    "retailer": ['retaileradmin', 'retailer', 'kitchenretaileradmin', 'kitchenretailer'],
    "kitchenretaileradmin": ['retaileradmin', 'retailer', 'kitchenretaileradmin', 'kitchenretailer'],
    "kitchenretailer": ['retaileradmin', 'retailer', 'kitchenretaileradmin', 'kitchenretailer'],
    "deliveryagent": ['deliveryagent'],
    "serviceprovider": ['serviceprovider'],
    "user": ['user'],
    "userrep": ['userrep', 'telecaller'],
    "telecaller": ['userrep', 'telecaller'],
  }

  constructor() { }

  validatePhoneNumber(phoneNum: string, userRole: string = 'zoneadmin'): Observable<{
    status: PhoneNumbCheckStatus;
    user?: { name: string; email: string, id: string };
  }> {
    return this.apiService.phoneUserValidation({ phone: phoneNum }).pipe(
      map((response) => {
        if (response.data) {
          const userData = response.data;
          const userRoleMain = this.userRoles[userRole] || [];
          const userRoles = Array.isArray(userData.role) ? userData.role : [];
          const notInArray2 = userRoles.filter(item => userRoleMain.includes(item));
          if (notInArray2.length > 0) {
            this.toastr.error(response.message, '', { timeOut: 3000 });
            return {
              status: PhoneNumbCheckStatus.ERROR,
              user: {
                name: '',
                email: '',
                id: ''
              },
            };
          }

          this.toastr.success(response.message, '', { timeOut: 3000 });
          return {
            status: PhoneNumbCheckStatus.WARNING,
            user: {
              name: userData.name,
              email: userData.email,
              id: userData._id
            },
          };
        } else {
          return {
            status: PhoneNumbCheckStatus.SUCCESS,
            user: {
              name: '',
              email: '',
              id: ''
            },
          };
        }
      }),
      catchError((err) => {
        this.toastr.error(err.message || 'An error occurred', '', { timeOut: 3000 });
        return throwError(() => err);
      })
    );
  }
}
